/* Auto Generated */

export enum ExpertPageState {
	created,
	appliedForApproval,
	waitingForContract,
	approved,
	revoked,
}
